import React from "react";

import { Navbar } from 'react-bootstrap';
import DatumLogo from "./DatumLogo";

type OrgoLogoProps = {
    name: string,
    bgColor?: string,
    logo?: any
}


const OrgLogo = ({ name, logo, bgColor = '#343a40' }: OrgoLogoProps) => {
    return (
        <div className="d-flex justify-content-around nav navbar-logo-parent" style={{ backgroundColor: bgColor }}>
            <Navbar.Brand>
                {logo ?
                    <a href="/">
                        <img
                            src={logo}
                            className="d-inline-block align-middle logo-padding"
                            style={{ height: '25px' }}
                            alt={name}
                        />
                    </a> :
                    <DatumLogo />
                }
            </Navbar.Brand>
        </div>
    );
}

export default OrgLogo;
